//WW-1163 PC_WW_1163_28-31 -Vishwa S
import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';

//WW-1163 PC_WW_1163_32-42 -Vishwa S
class InteractiveDiagramStore extends EventEmitter {
    pageLoadResponse = "";
    handleInteractiveDiagramStore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.Interactive_PageLoad: {
                this.pageLoadResponse = action.action.response;
                ;
                this.emit('pageLoad');
                break;
            }
        }
    }
}
const interactiveStore = new InteractiveDiagramStore;
// Dispatcher code
Dispatcher.register(interactiveStore.handleInteractiveDiagramStore.bind(interactiveStore));
export default interactiveStore;